import React, { useState } from "react";

import { Plus, Upload } from "lucide-react";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";

import { Button } from "@/src/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/src/components/ui/dropdown-menu";

import UsersAdminModal from "./UsersAdminModal";
import { PROJECTS_ROUTE } from "../../routes/routes";

import type { JSX } from "react";

import type { ImportedUser } from "../../../api/AdminUserAPI.types";

interface UsersCreateButtonProps {
  cleanImport: () => void;
  importedUsers: ImportedUser[];
  importError: string;
  upload: (file: File, type: string, notifications: unknown) => void;
}

function UsersCreateButton({
  cleanImport,
  importedUsers,
  importError,
  upload,
}: UsersCreateButtonProps): JSX.Element {
  const { t } = useTranslation("editor-users");
  const history = useHistory();
  const { projectSlug } = useParams<{ projectSlug: string }>();
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleCreate = (): void => {
    history.push(`${PROJECTS_ROUTE}/${projectSlug}/users/new/`);
  };

  return (
    <React.Fragment>
      <UsersAdminModal
        cleanImport={cleanImport}
        importedUsers={importedUsers}
        importError={importError}
        onClose={() => setIsModalOpen(false)}
        open={isModalOpen}
        upload={upload}
      />
      <DropdownMenu modal={false}>
        <DropdownMenuTrigger asChild>
          <Button size="lg" type="button">
            <Plus />
            {t("createUser")}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={handleCreate}>
            <Plus />
            {t("createUser")}
          </DropdownMenuItem>
          <DropdownMenuItem onSelect={() => setIsModalOpen(true)}>
            <Upload />
            {t("usersImport")}
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </React.Fragment>
  );
}

export default UsersCreateButton;
